import "./index.scss"

import React, {useState} from "react"
import {Helmet} from "react-helmet"
import Popup from "reactjs-popup"
import InfiniteScroll from "react-infinite-scroll-component"

import Protected from "../../components/Protected/Protected"
import EmployeePositionsTable from "./components/EmployeePositionsTable"
import CreateUpdatePositionPopup from "./components/CreateUpdatePositionPopup"

import StyledCircularProgress from "../../toolkits/CircularProgress/CircularProgress"
import SearchForm from "../../toolkits/SearchForm/SearchForm"
import SmallButton from "../../toolkits/SmallButton/SmallButton"
import AlertMessage from "../../toolkits/AlertMessage/AlertMessage"

import {PERMISSIONS} from "../../constants/permissions"
import {useGetEmployeePositionsQuery} from "../../api/employeePositions"
import {useTableData} from "../../hooks/common/useTableData"
import {useTranslation} from "react-i18next"


const EmployeePositions = () => {
    const {t} = useTranslation("common")

    const [userMessage, setUserMessage] = useState(null)
    const [createUpdateEmployeePositionPopup, setCreateUpdateEmployeePositionPopup] = useState(false)

    const {items, params, hasMore, empty, loadNextPage, reset, changeParams } = useTableData(useGetEmployeePositionsQuery, "employeePositions")

    const onSearchChange = (value) =>  changeParams({name: value})

    return (
        <>
            <Helmet>
                <title>{t("Employee Positions")} - Newsoft Inside</title>
            </Helmet>

            {userMessage && <AlertMessage setMessage={setUserMessage} message={userMessage.message} code={userMessage.code}/>}
            
            <div className="employee-positions">
                <div className="employee-positions-header">
                    <SearchForm defaultValue={params.name || ""} onChange={onSearchChange} debounceMs={500}/>
                    <Protected permissions={[PERMISSIONS.WRITE_EMPLOYEE_POSITION]}>
                        <div className="employee-positions-header-button">
                            <SmallButton onClick={() => setCreateUpdateEmployeePositionPopup(true)}>
                                {t("Add new position").toUpperCase()}
                            </SmallButton>
                        </div>
                    </Protected>
                </div>
                <InfiniteScroll
                    pageStart={1}
                    next={loadNextPage}
                    hasMore={hasMore}
                    dataLength={items.length}
                    loader={<StyledCircularProgress/>}
                >
                    <div className="employee-positions-content">
                        <EmployeePositionsTable
                            employeePositions={items}
                            onSubmit={reset}
                            setUserMessage={setUserMessage}
                            empty={empty}
                        />
                    </div>)
                </InfiniteScroll>
            </div>

            <Popup
                open={createUpdateEmployeePositionPopup}
                closeOnDocumentClick={false}
                onClose={() => setCreateUpdateEmployeePositionPopup(false)}
                modal
            >
                {close => (
                    <CreateUpdatePositionPopup
                        onSubmit={reset}
                        setUserMessage={setUserMessage}
                        close={close}
                    />
                )}
            </Popup>

        </>)
}

export default EmployeePositions
